import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import FirebaseConfig from '../helpers/FirebaseConfig.js';
import firebaseAxios from '../helpers/firebaseAxios.js';

  class FirebaseSingleton{
    constructor(auth,functions,firestore,database,fba,tenant){
        

        this.auth      = auth;
        this.functions = functions;
        this.firestore = firestore;
        this.database  = database;
        this.fba       = fba;
        this.tenant    = tenant;

       
    }
    static async init(){
        if(!FirebaseSingleton.instance){
            const fireConf =  new FirebaseConfig();   
            fireConf.firebaseInitMainApp();
            let mainApp;      
            if(fireConf.getTenantInLocal()){
                mainApp =  await fireConf.getApp(fireConf.getTenantInLocal());
            }else{
                mainApp =  await fireConf.getApp();
            }
            const fba = new firebaseAxios();
            fba.setTenant(fireConf.getTenantInLocal())
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    
            if(process.env.VUE_APP_FIREBASE_ENV == "development"){
                firebase.firestore().settings({
                    host:process.env.VUE_APP_FIRESTORE_DEV_HOST,
                    ssl:false
                });   
                fba.useEmulator(process.env.VUE_APP_EMULATOR_IP);
               
            }
            FirebaseSingleton.instance = new FirebaseSingleton(firebase.auth(),firebase.functions(),firebase.firestore(),mainApp.database(),fba,fireConf.getTenantInLocal());
        }
        
       
        return FirebaseSingleton.instance
    }
    
}


export  {FirebaseSingleton}

